import { z } from 'zod';
const CPF_REGEX = /^(\d){11}$/;
const CPF_LENGTH = 11;
const CPF_LENGTH_WITHOUT_VD = 9;
const BASE_CPF_VALUE = '0'.charCodeAt(0);
const calculateVD = (base) => {
    let sumVD1 = 0;
    for (let i = 0; i < CPF_LENGTH_WITHOUT_VD; i++) {
        const n = base.charCodeAt(i) - BASE_CPF_VALUE;
        sumVD1 += n * (10 - i);
    }
    const dv1 = sumVD1 % 11 < 2 ? 0 : 11 - (sumVD1 % 11);
    let sumVD2 = 0;
    for (let i = 0; i < CPF_LENGTH_WITHOUT_VD; i++) {
        const n = base.charCodeAt(i) - BASE_CPF_VALUE;
        sumVD2 += n * (11 - i);
    }
    sumVD2 += dv1 * 2;
    const dv2 = sumVD2 % 11 < 2 ? 0 : 11 - (sumVD2 % 11);
    return `${dv1}${dv2}`;
};
const isCPFValid = (cpf) => {
    const informedVD = cpf.substring(CPF_LENGTH_WITHOUT_VD);
    const calculatedVD = calculateVD(cpf.substring(0, CPF_LENGTH_WITHOUT_VD));
    return informedVD === calculatedVD;
};
export const CpfVO = z
    .string()
    .length(CPF_LENGTH)
    .regex(CPF_REGEX)
    .refine(isCPFValid, 'CPF inválido');
//# sourceMappingURL=cpf.js.map